import DefaultDetail from "@Common/DefaultDetail";

import { inject, observer } from "mobx-react";
import { useLayoutEffect, useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const TestOffersDetail = inject("mainStore")(
    observer(({ mainStore }) => {
        const [sorts, setSorts] = useState([]);

        const { secondParam } = useParams();
        const data = mainStore.getMainStore("detailData");
        const offer = mainStore.getMainStore("defaultOffer");
        const sites_suggest = mainStore.getMainStore("modified.sites_suggest");

        const isDisabled = !data?.draft && secondParam !== "add";

        useEffect(() => {
            return () => mainStore.setMainStore("detailData", {});
        }, []);

        useLayoutEffect(() => {
            if (offer?._id) getSorts(offer._id);
        }, [offer, sites_suggest, secondParam]);

        const getSorts = async (id) => {
            const sorts = await mainStore.getByUrl(`/promo/offerbysitesorts`, { filters: { offerId: id } });
            if (sorts && sorts.success) {
                const modyfySorts = sorts.data.map((i) => ({ ...i, label: sites_suggest?.[i.siteId]?.name ?? "" }));
                if (secondParam == "add" && data.offerId) {
                    mainStore.setMainStore(
                        "detailData.siteIds",
                        modyfySorts.map((i) => i.siteId),
                    );
                }

                setSorts(modyfySorts);
            }
        };

        let inputs = [
            {
                blockName: "Тест для оффера",
                inputs: {
                    title: { label: "Укажите название теста", type: "string", required: true, addClass: "full", translitTo: "code", disabled: isDisabled },
                    description: { label: "Укажите описание теста", type: "textArea", required: true, addClass: "full", disabled: isDisabled },
                    code: { label: "Уникальный код", type: "string", required: true, addClass: "full", disabled: isDisabled },
                    vendorId: {
                        label: "Выберите вендор",
                        type: "selectSuggest",
                        filterBy: "name",
                        required: true,
                        dataKey: "suggest.vendors_suggest",
                        optionValue: "_id",
                        optionLabel: "name",
                        placeholder: "Список вендоров",
                        refetchOnMountData: true,
                        apiUrl: "/promo/suggest_list?collection=vendors&project[name]=1&project[active]=1&project[archived]=1&filters[active]=true&sortField=name&sortOrder=asc",
                        addClass: "full",
                        disabled: isDisabled,
                    },
                    offerId: {
                        label: "Выберите оффер",
                        type: "selectSuggest",
                        filterBy: "technicalName, _id",
                        required: true,
                        dataKey: "suggest.offers_suggest",
                        optionValue: "_id",
                        optionLabel: "technicalName",
                        placeholder: "Список офферов",
                        refetchOnMountData: true,
                        apiUrl: "/promo/suggest_list?collection=offers&project[technicalName]=1&project[vendorId]=1&project[active]=1&project[archived]=1&filters[active]=true&sortField=name&sortOrder=asc",
                        filterFunction: ({ options, currentValue }) => {
                            return options.filter((it) => it?.vendorId === currentValue.vendorId);
                        },
                        addClass: "full",
                        triggerShow: "vendorId",
                        disabled: isDisabled,
                    },
                    siteIds: {
                        label: "Выберите Витрины, где проводится тест",
                        type: "multiSelect",
                        options: sorts,
                        optionValue: "siteId",
                        optionLabel: "label",
                        placeholder: "Список проектов",
                        addClass: "full",
                        showSelectAll: true,
                        triggerShow: "offerId",
                        disabled: isDisabled,
                    },
                    dateStart: { label: "Дата начала теста", type: "dateTime", required: true },
                    dateEnd: { label: "Дата конца теста", type: "dateTime", required: true },
                },
            },
        ];

        return (
            <DefaultDetail
                title={"АБ тесты / Офферы"}
                apiUrl={secondParam === "add" ? "/abtest/aboffers" : `/abtest/aboffers/${secondParam}`}
                dataKey={secondParam}
                scopes={false}
                inputs={inputs}
                titleList={"title"}
                titleRight={"офферы"}
                logging={true}
                page={"absites"}
                abTest={true}
            />
        );
    }),
);

export default TestOffersDetail;
